export default "<button title=\"{{'BUTTONS.CANCEL' | translate}}\" class=\"btn btn-dark\" (click)=\"cancel()\">{{'BUTTONS.CANCEL' | translate}}</button>\r\n";